import type { FaireProductEntity } from "../../entity_types/product";

export const p_uw6y8kswhb: FaireProductEntity = {
  token: "p_uw6y8kswhb",
  type: "product",
  name: "Tipsy Turvy Wine Stopper, Cherry",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/5acc67050a62a4c013d72389e794ce161a0904f1f376d85c7913f0a0f6b57742.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/95d6cc2817d686159e1d70dad9f5ab3d8179646bf4afa69c882758283c2b1b45.jpeg",
    "https://cdn.faire.com/fastly/6259a6e7f756908484088f5214dda80d9a4379e8979ea51d50b9467aca6fea10.jpeg"
  ],
  priceDollars: 9.5,
  description: "Stop everything! We made a wine stopper! And it’s very cute. This Bando wine stopper is equal parts fun and functional, designed to keep your favorite bottles fresh in style. It features a rubber ring that helps prevent pesky leaks, making it perfect for parties, gifts, or your own at-home happy hour setup.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n\n• Adorable, Bando-designed wine stopper\n• Rubber ring for a secure, leak-preventing seal\n• Fits most standard wine bottles\n• Great for gifting, entertaining, and display\n• Combines playful design with practical function\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫:\n\n• Gift shops and lifestyle boutiques\n• Home goods and kitchen retailers\n• Wine and beverage stores\n• Event planners and party favor collections\n• Wholesale buyers seeking fun, functional bar accessories",
  tags: [],
  msrpDollars: 19.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:40.302Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
